import FormBaseModel from '@cp-models/FormBaseModel'
import Bill from '@cp-models-common/Bill'
import Address from '@cp-models-common/Address'
import Company from '@cp-models-common/Company'
import Plan from '@cp-models-common/Plan'
import Reseller from '@cp-models-common/Reseller'
import Tenant from '@cp-models-common/Tenant'

const CPLUG = 1

export default class Client extends FormBaseModel {
    casts()
    {
        return {
            'id': 'number',
            'tenant_id': 'number',
            'internal_id': 'number',
            'reseller_id': 'number',
            'payment_gateway_id': 'number',
            'main_company_id': 'number',
            'legal_name': 'string',
            'trade_name': 'string',
            'document': 'string',
            'charge_email': 'string',
            'owner_email': 'string',
            'phone': 'string',
            'activated_at': 'any',
            'blocked_at': 'any',
            'financial_warning_at': 'any',
            'archived_at': 'any',
            'inactivated_at': 'any',
            'has_pos_vindi': 'boolean',
            'internal_account': 'boolean',
            'first_plan_at': 'any',
            'address_id': 'number',
            'created_at': 'any',
            'updated_at': 'any',
            'deleted_at': 'any',
            'holding_name': 'string',
            'address': Address,
            'company': Company,
            'tenant': Tenant,
            'reseller': Reseller,
            'plans': [Plan],
            'plan': Plan,
            'bills': [Bill],
            'phone_formated': 'string',
        }
    }

    get activatedAt()
    {
        return this.formatDate(this.activated_at)
    }

    get blockedAt()
    {
        return this.formatDate(this.blocked_at)
    }

    get financialWarningAt()
    {
        return this.formatDate(this.financial_warning_at)
    }

    get archivedAt()
    {
        return this.formatDate(this.archived_at)
    }

    get inactivatedAt()
    {
        return this.formatDate(this.inactivated_at)
    }

    get firstPlanAt()
    {
        return this.first_plan_at ? this.formatDate(this.first_plan_at) : ''
    }

    get createdAt()
    {
        return this.formatDate(this.created_at)
    }

    get updatedAt()
    {
        return this.formatDate(this.updated_at)
    }

    get deletedAt()
    {
        return this.formatDate(this.deleted_at)
    }

    get currentPlan()
    {
        return this.plans.length
            ? _.sortBy(this.plans, ['selected_at'])[0]
            : (this.plan.id
                ? this.plan
                : null)
    }

    get subscriptionId()
    {
        return this.plans.length
            ? _.sortBy(this.plans, ['selected_at'])[0].subscriptionId
            : (this.plan.id
                ? this.plan.subscriptionId
                : null)
    }

    get subscription()
    {
        return `admin/subscriptions/${this.subscriptionId}`
    }

    get paymentGateway()
    {
        return `admin/customers/${this.payment_gateway_id}`
    }

    get status()
    {
        let status = 'Conta Ativa'

        if (this.blocked_at) {
            status = 'Conta Bloqueada'
        } else if (this.financial_warning_at) {
            status = 'Conta com Aviso Financeiro'
        } else if (this.archived_at || this.inactivated_at) {
            status = 'Conta Inativa'
        }

        if (this.tenant.deleted_at || this.deleted_at) {
            status = 'Conta excluída'
        }

        return status
    }
    get statusColor()
    {
        let status = 'green'

        if (this.blocked_at) {
            status = 'red'
        } else if (this.financial_warning_at) {
            status = 'yellow darken-3'
        } else if (this.archived_at || this.inactivated_at) {
            status = 'red darken-3'
        }

        if (this.tenant.deleted_at || this.deleted_at) {
            status = 'orange darken-3'
        }

        return status
    }

    get situation()
    {
        let situation = 'Situação: Ativo'

        if (this.archived_at) {
            situation = 'Situação: Arquivado'
        } else if (this.inactivated_at) {
            situation = 'Situação: Inativo'
        }

        if (this.tenant.deleted_at || this.deleted_at) {
            situation = 'Situação: Arquivado'
        }

        return situation
    }
    get situationColor()
    {
        let situation = 'green'

        if (this.archived_at) {
            situation = 'red'
        } else if (this.inactivated_at) {
            situation = 'red darken-3'
        }

        if (this.tenant.deleted_at || this.deleted_at) {
            situation = 'orange darken-3'
        }

        return situation
    }

    get partner()
    {
        let text = 'Cliente '
        text += this.reseller_id != CPLUG
            ? `de ${this.reseller.typeReadable}`
            : 'Cplug'

        return text
    }
    get partnerColor()
    {
        return this.reseller_id != CPLUG
            ? this.reseller.typeColor
            : 'blue darken-2'
    }
    get partnerTextColor()
    {
        return this.reseller_id != CPLUG
            ? this.reseller.typeTextColor
            : 'white'
    }
}
